import React, {Component, Fragment} from "react";
import {Button, Typography} from "@material-ui/core";
import CustomerButton from "app/main/genericComponents/buttons/modelButtons/models/CustomerButton";
import {findCurrentCallCustomer} from "app/services/axios/Services/PbxQueues/pbxQueue";
import CircularProgress from "@material-ui/core/CircularProgress";
import PrimaryButton from "app/main/genericComponents/buttons/rectangleButtons/PrimaryButton";
import history from "@history";

class InCallShortcut extends Component {

    constructor(props) {
        super(props);
        this.initialState = {loading:true, message: "", customer_nos: []}
        this.state = this.initialState;
    };

    componentDidMount() {
        this.getCustomers();
    }

    componentWillUnmount() {
        this.setState(this._emptyState);
    }

    getCustomers() {
        this.setState({loading: true});

        findCurrentCallCustomer().then((response) => {
            console.log(response);
            this.setState({loading:false,message: response.data.data.message, customer_nos : response.data.data.customer_nos ? response.data.data.customer_nos : []});
        });
    }
    getMessage(message){
        switch (message){
            case "Call and customer found !" :
                return "En appel avec :"
            case "No customer found !" :
                return "En appel : Aucun client trouvé."
            case "No call found !" :
                return "Pas en appel"
            case "No extension configured !" :
                return "Extension non configurée."
            default:
               return  "";
        }
    }

    render() {
        if(this.state.loading){
            return <CircularProgress color={"secondary"}/>
        }
        return <>
            <Typography align={"center"}>{this.getMessage(this.state.message)}</Typography>
            <>
                <div align={"center"}>
                {
                    this.state.customer_nos.map((customerNo) => (
                        <CustomerButton align={"center"} customer={{customer_no : customerNo}}/>
                    ))
                }
                </div>
            </>
            <div align={"center"}>

                <PrimaryButton  onClick={() => this.getCustomers()} buttontext={"Rafraichir"}/>
            </div>
        </>
    }
}

export default InCallShortcut;
